var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 24 24",
    id: "google-play",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 40,
    y: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M427.176,289.399C427.833,289.013 428.695,288.994 429.544,289.448L445.567,298.015C446.783,298.665 446.901,299.556 446.9,300.001C446.9,300.447 446.782,301.337 445.567,301.986L440.504,304.693C440.495,304.698 440.486,304.703 440.477,304.708L429.544,310.553C429.113,310.783 428.675,310.891 428.269,310.891C427.874,310.891 427.503,310.792 427.177,310.602L427.162,310.593C427.156,310.589 427.149,310.585 427.143,310.581L427.138,310.578C426.488,310.178 426.067,309.427 426.067,308.472L426.067,291.53C426.067,290.57 426.49,289.817 427.14,289.421C427.151,289.413 427.163,289.406 427.176,289.399ZM427.867,308.206L435.307,300L427.867,291.794L427.867,308.206ZM430.466,308.019L438.623,303.658L436.522,301.34L430.466,308.019ZM440.26,297.218L437.737,300L440.26,302.783L444.718,300.399C444.998,300.249 445.1,300.104 445.1,299.999C445.1,299.896 444.998,299.752 444.718,299.602L440.26,297.218ZM436.522,298.66L438.623,296.343L430.468,291.983L436.522,298.66Z",
    transform: "translate(-384 -248)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.c10fd9cbd47b70577fc313e4b81932c5.svg";
export { ForwardRef as ReactComponent };